var SUPERSTRONG = (!SUPERSTRONG ? {} :SUPERSTRONG);
(function (gmap){
	SUPERSTRONG.GmapController = (function (msg){

		var _instance;

		var _gmap = function(){
			return {
				_map:{},
				_msg:new Date().getTime(),
				injectMap: function (options){

					var opts = {
		                div: options.target || "#map-canvas",
		                lat: options.lat || 50.464422,
		                lng: options.lng || 4.868157999999994,
		                zoom:options.zoom || 17,
		                panControl: options.panControl || false,
		                zoomControl: options.zoomControl || false,
		                scaleControl: options.scaleControl || false,
		                draggable: options.draggable || true,
		                scrollwheel: options.scrollwheel || false,
		                mapTypeId: options.mapTypeId || google.maps.MapTypeId.ROADMAP

		            }

					this._map = new gmap(opts);
					return this;


				},
				addMarker:function (markers,centerMap){

					if (!this._map || !markers){return;}
					if ( markers.push !== undefined){
						var latLngs = [];
						for (var marker in markers){
							latLngs.push(new google.maps.LatLng(markers[marker].lat,markers[marker].lng));
							this._map.addMarker({
								lat: parseFloat(markers[marker].lat),
 							   	lng:parseFloat(markers[marker].lng),
								title:markers[marker].title,
								infoWindow:markers[marker].infoWindow

							});
						}
						if (centerMap)this._map.fitLatLngBounds(latLngs);
					}

					if (typeof markers === 'object'){

						   this._map.addMarker({
							   lat: parseFloat(markers.lat),
							   lng:parseFloat(markers.lng),
							   title:markers.title,
							   infoWindow:markers.infoWindow

						   });

						   if (centerMap)this._map.setCenter(parseFloat(markers.lat),parseFloat(markers.lng))
					}

					return this;

				}
			}
		}

		function __create (){
			return new _gmap();

		};
		return {
			getInstance:function (){

				if (!_instance){
					_instance = __create();
				};
				return _instance;
			}

		}


	}
	)()
})(GMaps);
